import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../constants";
import Select from "react-select";
import {
  DeleteServiceCaller,
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import CustomDatePicker from "../../../components/Custom-Datepicker";
import moment from "moment";

const CurrencyMasterForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  useEffect(() => {
    fetchCurrency();

    dispatch(updateNavbarHeading(`${id ? "Edit" : "Add"} Currency Master`));
  }, []);

  const initialFormData = {
    Code: "",
    Name: "",
    Description: "",
    NoOfDecimalPrecision: "",
    CurrencySymbol: "",
    CurrencyName: "",
    DecimalPrecisionName: "",
    DecimalPrecisionSymbol: "",
    Culture_182: "",
    CurrencyScaleType_058: "",
    IsPrefixSymbol: false,
    IsInActive: false,
    IsExchangeCurrency: false,
    lines: [
      {
        CurrencyID: "",
        LineNo: 1,
        ToCurrencyID: "",
        ExchangeRate: "",
        FromDate: "",
        ToDate: "",
        ObjectType: "",
      },
    ],
  };
  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  const [Cultureoptions, setCultureOptions] = useState([]);
  const [currencyScale, setCurrencyScale] = useState([]);
  const [ObjectType, setObjectType] = useState([]);
  const [toCurrencies, setToCurrencies] = useState([]);
  const [errors, setErrors] = useState({});
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const handlecheckedChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value ? 1 : 0,
    }));
  };
  const fetchData = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}currency-master/${id}`
      );
      if (response.status === 200) {
        const {
          Code,
          Name,
          Culture_182,
          CurrencyScaleType_058,
          IsPrefixSymbol,
          IsExchangeCurrency,
          Description,
          IsInActive,
          CurrencySymbol,
          NoOfDecimalPrecision,
          CurrencyName,
          DecimalPrecisionName,
          DecimalPrecisionSymbol,
        } = response?.data?.data?.currency || {};
        const currencyVersion = response?.data?.data?.currencyConversion || [];

        const isInActiveValue = IsInActive === 1;

        const lines = currencyVersion.map((version) => ({
          CurrencyID: id,
          LineNo: version.LineNo,
          ObjectType: version.ObjectType,
          ToCurrencyID: version.ToCurrencyID,
          ExchangeRate: version.ExchangeRate,
          FromDate: version.FromDate,
          ToDate: version.ToDate,
          ID: version.ID,
          IsInActive: isInActiveValue,
          Remark: version.Remark || "",
        }));

        setFormData({
          id,
          Code,
          Name,
          Culture_182,
          CurrencyScaleType_058,
          IsPrefixSymbol,
          Description,
          NoOfDecimalPrecision,
          IsExchangeCurrency,
          CurrencySymbol,
          CurrencyName,
          DecimalPrecisionName,
          DecimalPrecisionSymbol,
          IsInActive,
          lines: lines,
        });

        // setRows(lines);
      } else {
        console.error(
          "Failed to fetch course details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching course details:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id]);
  const fetchCurrency = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}currency-master`);
      if (response?.status === 200) {
        // Culture option
        const options = response?.data?.data?.currencyCulture.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setCultureOptions(options);
        // currency scale type
        const scaleType = response?.data?.data?.currencyScaleType.map(
          (item) => ({
            value: item.value,
            label: item.text,
          })
        );
        setCurrencyScale(scaleType);
        // Object type
        const ObjectTypes = response?.data?.data?.objectTypes.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setObjectType(ObjectTypes);
        // toCurrency
        const toCurrencies = response?.data?.data?.toCurrency.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setToCurrencies(toCurrencies);
        const data = response?.data?.data?.data;
        const allNames = data.map((item) => item.Name);
        setSuggestions(allNames);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  useEffect(() => {}, []);

  // 1. Update the validateForm function to include CurrencyScaleType_058 validation
  const validateForm = () => {
    const newErrors = {};
    if (!formData.Code) newErrors.Code = "Code is required";
    if (!formData.Name) newErrors.Name = "Name is required";
    if (!formData.NoOfDecimalPrecision)
      newErrors.NoOfDecimalPrecision = "Decimal Precision is required";
    if (!formData.CurrencyName)
      newErrors.CurrencyName = "Currency Name is required";
    if (!formData.CurrencySymbol)
      newErrors.CurrencySymbol = "Currency Symbol is required";
    if (!formData.DecimalPrecisionName)
      newErrors.DecimalPrecisionName = "Decimal Precision Name is required";
    // Add validation for Currency Scale Type
    if (!formData.CurrencyScaleType_058)
      newErrors.CurrencyScaleType_058 = "Currency Scale Type is required";
    if (!formData.Culture_182) newErrors.Culture_182 = "Culture is required";

    // Validate relation array
    formData.lines.forEach((line, index) => {
      const lineErrors = {};

      if (!line.ToCurrencyID) {
        lineErrors.ToCurrencyID = "To Currency is required";
      }

      if (!line.FromDate) {
        lineErrors.FromDate = "From Date is required";
      }

      if (Object.keys(lineErrors).length > 0) {
        newErrors[index] = lineErrors;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 2. Update the handleChange function to clear errors when CurrencyScaleType_058 changes
  const handleChange = (name, value) => {

        if (name === "Name") {
      const matchedSuggestions = suggestions.filter((suggestion) =>
        suggestion.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(matchedSuggestions);
      setShowSuggestions(value.length > 0 && matchedSuggestions.length > 0);
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear error when field is changed
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);

      // Prepare the data
      const payload = {
        ...formData,
        lines: formData.lines.map((row) => ({
          ...row,
          FromDate: row.FromDate
            ? moment(row.FromDate).format("YYYY-MM-DD")
            : null,
          ToDate: row.ToDate ? moment(row.ToDate).format("YYYY-MM-DD") : null,
        })),
      };

      try {
        const url = `${API_URL}currency-master${
          formData.id ? `/${formData.id}` : ""
        }`;
        const method = formData.id ? "put" : "post";
        const response = await PostServiceCaller(url, payload, method);

        if (response.status === 200) {
          toast.success("Data submitted successfully");
          setTimeout(() => {
            window.location.href = "/currency-master";
          }, 2000);
        } else {
          console.error("Submission failed:", response);
          toast.error("Failed to submit data");
        }
      } catch (error) {
        console.error("Submission error:", error);
        if (error.response) {
          // Handle specific backend errors
          const errorMsg = error.response.data?.message || "An error occurred";
          toast.error(errorMsg);
        } else {
          console.error("Network error - please try again");
        }
      } finally {
        setLoading(false);
      }
    }
  };

  // Dynamic Rows

  const handleLineChanged = (e, rowIndex, fieldName) => {
    const { value } = e.target || { value: e };
    const updatedLines = formData.lines.map((line, index) =>
      index === rowIndex ? { ...line, [fieldName]: value } : line
    );

    setFormData((prev) => ({ ...prev, lines: updatedLines }));

    // Validate the specific field
    const newErrors = {};
    if (!value || value.trim() === "") {
      newErrors[fieldName] = "This field is required.";
    }

    setErrors((prev) => ({
      ...prev,
      [rowIndex]: { ...prev[rowIndex], [fieldName]: newErrors[fieldName] },
    }));
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      const inputElement = document.getElementById("Name");
      const suggestionsElement = document.querySelector(
        ".suggestions-container"
      );

      // Close suggestions if click is outside both input and suggestions
      if (
        showSuggestions &&
        !inputElement.contains(event.target) &&
        (!suggestionsElement || !suggestionsElement.contains(event.target))
      ) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSuggestions]);
  const handleLineSelectChange = (selectedOption, name, rowIndex) => {
    const updatedLines = formData.lines.map((line, index) =>
      index === rowIndex ? { ...line, [name]: selectedOption.value } : line
    );

    const newErrors = {};
    if (!selectedOption.value) {
      newErrors[name] = "Please select a valid option.";
    }

    setFormData((prev) => ({ ...prev, lines: updatedLines }));
    if (errors[rowIndex]?.[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        if (newErrors[rowIndex]) {
          delete newErrors[rowIndex][name];
          // Remove the row from errors if no more errors exist
          if (Object.keys(newErrors[rowIndex]).length === 0) {
            delete newErrors[rowIndex];
          }
        }
        return newErrors;
      });
    }
  };

  const handleLineDateChange = (e, rowIndex) => {
    const { name, value } = e.target;
    const updatedLines = formData.lines.map((line, index) =>
      index === rowIndex ? { ...line, [name]: value } : line
    );

    setFormData((prev) => ({ ...prev, lines: updatedLines }));
    if (errors[rowIndex]?.[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        if (newErrors[rowIndex]) {
          delete newErrors[rowIndex][name];
          // Remove the row from errors if no more errors exist
          if (Object.keys(newErrors[rowIndex]).length === 0) {
            delete newErrors[rowIndex];
          }
        }
        return newErrors;
      });
    }
  };

  const handleAddPOCLine = () => {
    const currentRow =
      formData.lines.length !== 0
        ? formData.lines[formData.lines.length - 1]
        : null;

    if (currentRow && currentRow.ToCurrencyID === "") {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    // Find the first available LineNo (missing number in sequence)
    const existingLineNos = formData.lines.map((line) => line.LineNo);
    let newLineNo = 1;

    // Look for the first gap in LineNo (if any)
    while (existingLineNos.includes(newLineNo)) {
      newLineNo++;
    }

    // Create a new line with the next available LineNo
    const newLine = {
      LineNo: newLineNo,
      CurrencyID: "",
      ObjectType: "",
      ToCurrencyID: "",
      ExchangeRate: "",
      FromDate: "",
      ToDate: "",
    };

    // Add the new line and ensure LineNos are correctly filled
    setFormData((prev) => ({
      ...prev,
      lines: [...prev.lines, newLine],
    }));
  };

  const handleDeletePOCLine = async (rowIndex, ID) => {
    if (ID) {
      try {
        await DeleteServiceCaller(
          `${API_URL}clientmaster-rompoc-delete/${ID}`,
          {},
          "delete"
        );
        const updatedLines = formData.lines.filter((_, i) => i !== rowIndex);

        // Reassign LineNo after deletion (to fill the gap)
        const updatedLinesWithCorrectLineNo = updatedLines.map(
          (line, index) => ({
            ...line,
            LineNo: index + 1, // Reassign LineNo in sequence
          })
        );

        setFormData({ ...formData, lines: updatedLinesWithCorrectLineNo });
      } catch (error) {
        console.error("There was an error deleting the line!", error);
      }
    } else {
      const updatedLines = formData.lines.filter((_, i) => i !== rowIndex);

      // Reassign LineNo after deletion (to fill the gap)
      const updatedLinesWithCorrectLineNo = updatedLines.map((line, index) => ({
        ...line,
        LineNo: index + 1, // Reassign LineNo in sequence
      }));

      setFormData({ ...formData, lines: updatedLinesWithCorrectLineNo });
    }
  };

  return (
    <>
      <div className="Container ">
        <form
          onSubmit={handleSubmit}
          id="formOne"
          className="rounded mt-2 bg-white"
        >
          <div className="p-1">
            <div class="card-body  mx-2">
              <div className="row">
                <div className="container">
                  <div className="row">
                    <div className="col-xl-3 col-md-6 col-lg-3 mb-3">
                      <label htmlFor="Code" className="form-label">
                        Code<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.Code ? "is-invalid" : ""
                        }`}
                        id="Code"
                        name="Code"
                        value={formData.Code}
                        onChange={(e) => handleChange("Code", e.target.value)}
                      />
                      {errors.Code && (
                        <div className="invalid-feedback">{errors.Code}</div>
                      )}
                    </div>
                    <div className="col-xl-3 col-md-6 col-lg-3 mb-3">
                      <label htmlFor="Name" className="form-label">
                        Name<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.Name ? "is-invalid" : ""
                        }`}
                        id="Name"
                        name="Name"
                        value={formData.Name}
                        onChange={(e) => handleChange("Name", e.target.value)}
                        autoComplete="off"
                      />
                      {showSuggestions && filteredSuggestions.length > 0 && (
                        <div
                          className="suggestions-container"
                          style={{
                            position: "absolute",
                            width: "22%",
                            maxHeight: "200px",
                            overflowY: "auto",
                            backgroundColor: "#fff",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            zIndex: 1000,
                            marginTop: "2px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent event from bubbling to document
                            setShowSuggestions(false); // Close when clicked
                          }}
                        >
                          <div
                            style={{
                              padding: "8px 12px",
                              fontSize: "0.8rem",
                              color: "#666",
                              borderBottom: "1px solid #eee",
                              backgroundColor: "#f8f9fa",
                            }}
                          >
                            Existing matching Currency:
                          </div>
                          <ul
                            style={{
                              listStyle: "none",
                              padding: 0,
                              margin: 0,
                            }}
                          >
                            {filteredSuggestions.map((suggestion, index) => (
                              <li
                                key={index}
                                style={{
                                  padding: "8px 12px",
                                  fontSize: "0.9rem",
                                  borderBottom: "1px solid #eee",
                                  color: "#333",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setFormData((prev) => ({
                                    ...prev,
                                    Name: suggestion,
                                  }));
                                  setShowSuggestions(false);
                                }}
                              >
                                {suggestion}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      {errors.Name && (
                        <div className="invalid-feedback">{errors.Name}</div>
                      )}
                    </div>
                    <div className="col-xl-3 col-md-6 col-lg-3 mb-3">
                      <label htmlFor="Description" className="form-label">
                        Description
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="Description"
                        name="Description"
                        value={formData.Description}
                        onChange={(e) =>
                          handleChange("Description", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-xl-3 col-md-6 col-lg-3 mb-3">
                      <label
                        htmlFor="NoOfDecimalPrecision"
                        className="form-label"
                      >
                        No. Of Decimal Precision
                        <span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        className={`form-control ${
                          errors.NoOfDecimalPrecision ? "is-invalid" : ""
                        }`}
                        id="NoOfDecimalPrecision"
                        name="NoOfDecimalPrecision"
                        value={formData.NoOfDecimalPrecision}
                        onChange={(e) =>
                          handleChange("NoOfDecimalPrecision", e.target.value)
                        }
                      />
                      {errors.NoOfDecimalPrecision && (
                        <div className="invalid-feedback">
                          {errors.NoOfDecimalPrecision}
                        </div>
                      )}
                    </div>
                    <div className="col-xl-3 col-md-6 col-lg-3 mb-3">
                      <label htmlFor="Culture_182" className="form-label">
                        Culture<span className="required">*</span>
                      </label>
                      <Select
                        type="text"
                        value={Cultureoptions.find(
                          (option) => option.value === formData.Culture_182
                        )}
                        onChange={(selectedOption) =>
                          handleChange("Culture_182", selectedOption.value)
                        }
                        options={Cultureoptions}
                        name="Culture_182"
                        id="Culture_182"
                        className={`form-control p-0 ${
                          errors.Culture_182 ? "is-invalid" : ""
                        }`}
                        aria-describedby="type"
                      />
                      {errors.Culture_182 && (
                        <div className="invalid-feedback">
                          {errors.Culture_182}
                        </div>
                      )}
                    </div>
                    <div className="col-xl-3 col-md-6 col-lg-3 mb-3">
                      <label htmlFor="CurrencyName" className="form-label">
                        Currency Name<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.CurrencyName ? "is-invalid" : ""
                        }`}
                        id="CurrencyName"
                        name="CurrencyName"
                        value={formData.CurrencyName}
                        onChange={(e) =>
                          handleChange("CurrencyName", e.target.value)
                        }
                      />
                      {errors.CurrencyName && (
                        <div className="invalid-feedback">
                          {errors.CurrencyName}
                        </div>
                      )}
                    </div>
                    <div className="col-xl-3 col-md-6 col-lg-3 mb-3">
                      <label htmlFor="CurrencySymbol" className="form-label">
                        Currency Symbol<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.CurrencySymbol ? "is-invalid" : ""
                        }`}
                        id="CurrencySymbol"
                        name="CurrencySymbol"
                        value={formData.CurrencySymbol}
                        onChange={(e) =>
                          handleChange("CurrencySymbol", e.target.value)
                        }
                      />
                      {errors.CurrencySymbol && (
                        <div className="invalid-feedback">
                          {errors.CurrencySymbol}
                        </div>
                      )}
                    </div>
                    <div className="col-xl-3 col-md-6 col-lg-3 mb-3">
                      <label
                        htmlFor="DecimalPrecisionName"
                        className="form-label"
                      >
                        Decimal Precision Name
                        <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.DecimalPrecisionName ? "is-invalid" : ""
                        }`}
                        id="DecimalPrecisionName"
                        name="DecimalPrecisionName"
                        value={formData.DecimalPrecisionName}
                        onChange={(e) =>
                          handleChange("DecimalPrecisionName", e.target.value)
                        }
                      />
                      {errors.DecimalPrecisionName && (
                        <div className="invalid-feedback">
                          {errors.DecimalPrecisionName}
                        </div>
                      )}
                    </div>
                    <div className="col-xl-3 col-md-6 col-lg-3 mb-3">
                      <label
                        htmlFor="DecimalPrecisionSymbol"
                        className="form-label"
                      >
                        Decimal Precision Symbol
                        {/* <span className="required"> *</span> */}
                      </label>
                      <input
                        type="text"
                        // className={`form-control
                        //   ${
                        //   errors.DecimalPrecisionSymbol ? "is-invalid" : ""
                        // }
                        // `}
                        className="form-control"
                        id="DecimalPrecisionSymbol"
                        name="DecimalPrecisionSymbol"
                        value={formData.DecimalPrecisionSymbol}
                        onChange={(e) =>
                          handleChange("DecimalPrecisionSymbol", e.target.value)
                        }
                      />
                      {errors.DecimalPrecisionSymbol && (
                        <div className="invalid-feedback">
                          {errors.DecimalPrecisionSymbol}
                        </div>
                      )}
                    </div>
                    <div className="col-xl-3 col-md-6 col-lg-3 mb-3">
                      <label
                        htmlFor="CurrencyScaleType_058"
                        className="form-label"
                      >
                        Currency Scale Type<span className="required">*</span>
                      </label>
                      <Select
                        id="type"
                        value={currencyScale.find(
                          (option) =>
                            option.value === formData.CurrencyScaleType_058
                        )}
                        onChange={(selectedOption) =>
                          handleChange(
                            "CurrencyScaleType_058",
                            selectedOption.value
                          )
                        }
                        options={currencyScale}
                        className={`form-control p-0 ${
                          errors.CurrencyScaleType_058 ? "is-invalid" : ""
                        }`}
                        aria-describedby="CurrencyScaleType_058"
                      />
                      {errors.CurrencyScaleType_058 && (
                        <div className="invalid-feedback d-block">
                          {errors.CurrencyScaleType_058}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Switch buttons */}

                <div className="row  ms-2">
                  <div className="col-xl-3 col-md-6 col-lg-3 mb-3 form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="IsPrefixSymbol"
                      checked={formData.IsPrefixSymbol === 1}
                      onChange={(e) =>
                        handlecheckedChange("IsPrefixSymbol", e.target.checked)
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="IsPrefixSymbol"
                    >
                      Prefix Symbol
                    </label>
                  </div>
                  <div className="col-xl-3 col-md-6 col-lg-3 mb-3 form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="IsInActive"
                      checked={formData.IsInActive === 1}
                      onChange={(e) =>
                        handlecheckedChange("IsInActive", e.target.checked)
                      }
                    />
                    <label className="form-check-label" htmlFor="IsInActive">
                      Active
                    </label>
                  </div>
                  <div className="col-xl-3 col-md-6 col-lg-3 mb-3 form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="IsExchangeCurrency"
                      checked={formData.IsExchangeCurrency === 1}
                      onChange={(e) =>
                        handlecheckedChange(
                          "IsExchangeCurrency",
                          e.target.checked
                        )
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="IsExchangeCurrency"
                    >
                      Exchange Currency
                    </label>
                  </div>
                </div>
              </div>

              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-6">
                    <h3 className="heading skill-heading">
                      <i className="bi bi-currency-exchange"></i> Currency
                      Exchange
                    </h3>
                  </div>
                  <div className="col-lg-6">
                    <div className="text-end mb-2">
                      <button
                        type="button"
                        onClick={handleAddPOCLine}
                        className="custom-btn"
                      >
                        <i className="fa fa-plus"></i>Add
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive poc-head rounded mt-2">
                    <table id="poctable_head" className="table table-bordered">
                      <thead className="text-center">
                        <tr className="head">
                          <th>Sr. No. </th>
                          <th>Object Type</th>
                          <th>
                            To Currency<span className="required">*</span>
                          </th>
                          <th>Exchange Rate</th>
                          <th>
                            From Date<span className="required">*</span>
                          </th>
                          <th>To Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.lines.map((row, rowIndex) => (
                          <tr key={rowIndex} className="text-center">
                            <td>{rowIndex + 1}</td>

                            {/* Object Type */}
                            <td className="align-middle">
                              <label
                                htmlFor={`ObjectType-${rowIndex}`}
                                className="form-label d-none"
                              >
                                Object Type
                              </label>
                              <Select
                                id={`ObjectType-${rowIndex}`}
                                value={
                                  ObjectType.find(
                                    (option) => option.value === row.ObjectType
                                  ) || null
                                }
                                name="ObjectType"
                                onChange={(selectedOption) =>
                                  handleLineSelectChange(
                                    selectedOption,
                                    "ObjectType",
                                    rowIndex
                                  )
                                }
                                options={ObjectType}
                                className="form-control p-0"
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                menuPlacement="top"
                              />
                            </td>

                            {/* To Currency */}
                            <td className="align-middle">
                              <label
                                htmlFor={`ToCurrencyID-${rowIndex}`}
                                className="form-label d-none"
                              >
                                To Currency
                              </label>
                              <Select
                                id={`ToCurrencyID-${rowIndex}`}
                                value={
                                  toCurrencies.find(
                                    (option) =>
                                      option.value === row.ToCurrencyID
                                  ) || null
                                }
                                name="ToCurrencyID"
                                onChange={(selectedOption) =>
                                  handleLineSelectChange(
                                    selectedOption,
                                    "ToCurrencyID",
                                    rowIndex
                                  )
                                }
                                options={toCurrencies}
                                className={`form-control p-0 ${
                                  errors[rowIndex]?.ToCurrencyID
                                    ? "is-invalid"
                                    : ""
                                }`}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                menuPlacement="top"
                              />
                              {errors[rowIndex]?.ToCurrencyID && (
                                <div className="invalid-feedback d-block">
                                  {errors[rowIndex].ToCurrencyID}
                                </div>
                              )}
                            </td>

                            {/* Exchange Rate */}
                            <td className="align-middle">
                              <label
                                htmlFor={`ExchangeRate-${rowIndex}`}
                                className="form-label d-none"
                              >
                                Exchange Rate
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                id={`ExchangeRate-${rowIndex}`}
                                name="ExchangeRate"
                                value={row.ExchangeRate}
                                onChange={(e) =>
                                  handleLineChanged(e, rowIndex, "ExchangeRate")
                                }
                              />
                            </td>

                            {/* From Date */}
                            <td className="align-middle">
                              <label
                                htmlFor={`FromDate-${rowIndex}`}
                                className="form-label d-none"
                              >
                                From Date
                              </label>
                              <div
                                className={`${
                                  errors[rowIndex]?.FromDate ? "is-invalid" : ""
                                }`}
                              >
                                <CustomDatePicker
                                  handleChange={(e) =>
                                    handleLineDateChange(e, rowIndex)
                                  }
                                  id={`FromDate-${rowIndex}`}
                                  name="FromDate"
                                  className={`form-control ${
                                    errors[rowIndex]?.FromDate
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  value={
                                    row.FromDate
                                      ? moment(row.FromDate).format(
                                          "DD-MMM-YYYY"
                                        )
                                      : ""
                                  }
                                  placeholderText="DD-MM-YYYY"
                                />
                              </div>
                              {errors[rowIndex]?.FromDate && (
                                <div className="invalid-feedback d-block">
                                  {errors[rowIndex].FromDate}
                                </div>
                              )}
                            </td>
                            {/* To Date */}
                            <td className="align-middle">
                              <label
                                htmlFor={`ToDate-${rowIndex}`}
                                className="form-label d-none"
                              >
                                To Date
                              </label>
                              <CustomDatePicker
                                handleChange={(e) =>
                                  handleLineDateChange(e, rowIndex)
                                }
                                id={`ToDate-${rowIndex}`}
                                name="ToDate"
                                className="form-control"
                                value={
                                  row.ToDate
                                    ? moment(row.ToDate).format("DD-MMM-YYYY")
                                    : ""
                                }
                                placeholderText="DD-MM-YYYY"
                              />
                            </td>

                            {/* Action */}
                            <td>
                              <div
                                className="poc_delectbtn"
                                onClick={() =>
                                  handleDeletePOCLine(rowIndex, row.ID)
                                }
                              >
                                <i className="fa fa-trash-o"></i>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="container-fluid mt-3">
                    <div className="d-flex justify-content-end p-0 m-0">
                      <div className="d-flex">
                        <div>
                          <button
                            type="button"
                            className="cancel-btn me-2"
                            onClick={() => navigate("/currency-master")}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button type="submit" className="custom-btn">
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default CurrencyMasterForm;
